<template>
  <div class="projects-section">
    <h2 class="text-2xl font-bold mb-4" :style="{ color: themeColor, borderBottom: `2px solid ${themeColor}`, paddingBottom: '0.5rem' }">
      Projects
    </h2>
    <div v-for="(item, index) in section.data.items" :key="index" class="mb-4">
      <h3 class="text-xl font-semibold">
        {{ item.name || 'Project Name' }}
        <a
          v-if="item.url"
          :href="item.url"
          target="_blank"
          class="text-blue-600 hover:text-blue-800 text-sm ml-2"
        >
          (View)
        </a>
      </h3>
      <p class="text-gray-700 mb-2">{{ item.description || 'Project description' }}</p>
      <p v-if="item.technologies" class="text-sm text-gray-600">
        <strong>Technologies:</strong> {{ item.technologies }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#17803d'
    }
  }
}
</script>

